const CLAIM_STATUS_CONFIG = {
  close: { label: "Solicitação encerrada", variant: "success" },
  close_solicitation: { label: "Solicitação de encerramento", variant: "info" },
  refunded: { label: "Reembolsado", variant: "danger" },
  refund_pending: { label: "Solicitação de reembolso", variant: "danger" },
  refund_denied: { label: "Reembolso negado", variant: "danger" },
  refunded_automatically: { label: "Reembolso automático", variant: "info" },
  in_analysis: { label: "Em análise", variant: "info" },
  waiting_answer_seller: { label: "Aguardando resposta do Vendedor", variant: "info" },
  waiting_answer_client: { label: "Aguardando resposta do Cliente", variant: "info" },
};

export function getClaimStatus(status) {
  if (!status) return "Em aberto";

  const config = CLAIM_STATUS_CONFIG[status];

  return config ? config.label : "Status desconhecido";
}

export function getClaimStatusVariant(status) {
  if (!status) return "secondary";

  const config = CLAIM_STATUS_CONFIG[status];

  return config ? config.variant : "secondary";
}
